export default "__VITE_ASSET__Crapc$3y__"